import {
  ExperienceDto,
  UserInterfaceDto,
  VariationDto,
} from "@intelligems/ig-types";

export const getUserInterfacesFromExperienceDto = (
  experience: ExperienceDto
) => {
  const tempUserInterfaces: UserInterfaceDto[] = [];
  for (const userInterface of experience.userInterfaces ?? []) {
    tempUserInterfaces.push(userInterface);
  }
  for (const variation of experience.variations) {
    for (const userInterface of variation.userInterfaces ?? []) {
      tempUserInterfaces.push(userInterface);
    }
  }
  return tempUserInterfaces;
};
